module.exports = __webpack_public_path__ + "static/media/derecho-empresarial (2).58a05368.jpg";